import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import star from 'images/star-grey.svg'
import styles from './styles.module.scss'

interface Props {
  amount: number
}

export function Stars({ amount }: Props) {
  const starsArray = []
  let i = 0
  while (++i <= amount) {
    starsArray.push(i)
  }

  return (
    <span className={`ui images ${styles.stars}`}>
      {starsArray.map(i => {
        // Technically incorrect, as this would render "1 Sterne" – but I
        // somehow doubt that the hotel ranking is ever going to have a
        // 1-star hotel amongst its ranks.
        const altText = i === 1 ? `${amount} Sterne` : ''
        return (
          <img alt={altText} src={star} className="ui mini image" key={i} />
        )
      })}
    </span>
  )
}
